import request, { ApiResponse } from './request';

export interface SearchResult {
  customers: any[];
  villages: any[];
  sales: any[];
}

export function search(keyword: string, signal?: AbortSignal): Promise<ApiResponse<SearchResult>> {
  return request.get('/search', { params: { keyword }, signal });
}
